import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

export const CountCircle = styled.div`
  position: absolute;
  top: 2px;
  right: 4px;
  background-color: ${COLORS.primary};
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 0.125rem 0.5rem ${COLORS.altSecondary};
  cursor: pointer;
`;

export const Count = styled.div`
  color: ${COLORS.secondary};
  font-size: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;
